// extracted by mini-css-extract-plugin
module.exports = {"jobCard-media__imgWrap":"jobCard-media__imgWrap","jobCard-media__img":"jobCard-media__img"};